import type { SVGProps } from 'react';

export function ErrorIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M9.1665 12.4974H10.8332V14.1641H9.1665V12.4974ZM9.1665 5.83073H10.8332V10.8307H9.1665V5.83073ZM9.9915 1.66406C5.3915 1.66406 1.6665 5.3974 1.6665 9.9974C1.6665 14.5974 5.3915 18.3307 9.9915 18.3307C14.5998 18.3307 18.3332 14.5974 18.3332 9.9974C18.3332 5.3974 14.5998 1.66406 9.9915 1.66406ZM9.99984 16.6641C6.3165 16.6641 3.33317 13.6807 3.33317 9.9974C3.33317 6.31406 6.3165 3.33073 9.99984 3.33073C13.6832 3.33073 16.6665 6.31406 16.6665 9.9974C16.6665 13.6807 13.6832 16.6641 9.99984 16.6641Z"
        fill="currentColor"
      />
    </svg>
  );
}

